import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gtmPageView } from '../lib/gtm';

export function useGTMPageTracking() {
    const location = useLocation();

    useEffect(() => {
        // Small timeout lets the page title update before we capture it
        const id = setTimeout(() => {
            gtmPageView(location.pathname + location.search);
        }, 0);
        return () => clearTimeout(id);
    }, [location.pathname, location.search]);
}
